export const OPTIONS: {
  maxLength: number;
  minLength: number;
} = {
  maxLength: 20,
  minLength: 3,
};

export function execute(
  value: string | unknown,
  options: typeof OPTIONS = OPTIONS
): string[] {
  const errorMessages = {
    INVALID_TYPE: "INVALID_TYPE",
    TOO_SHORT: "TOO_SHORT",
    TOO_LONG: "TOO_LONG",
  };

  const errors: string[] = [];

  if (typeof value !== "string") {
    errors.push(errorMessages.INVALID_TYPE);
    return errors;
  }

  if (value.length < options.minLength) {
    errors.push(errorMessages.TOO_SHORT);
  }

  if (value.length > options.maxLength) {
    errors.push(errorMessages.TOO_LONG);
  }

  return errors;
}

export function isValid(value: string): boolean {
  return execute(value).length === 0;
}
